import { getCurrentInstance } from '@nuxtjs/composition-api'

export function useApolloProvider() {
  const currentInstance = getCurrentInstance()

  if (!currentInstance) {
    throw new Error('useI18n called and got currentInstance of null')
  }

  return currentInstance.proxy.$apolloProvider
}
